<template>
    <header data-role="Header" class="navigation-header">
        <div class="navigation-max-width">
            <api-image
                    :image="logo"
                    :title="title"
                    class="navigation-image"
            />
            <div class="navigation-nav">
                <navigation-links></navigation-links>
            </div>
        </div>
        <img
                src="/playground_assets/os-top1-700w.png"
                class="navigation-image1"
        />
    </header>
</template>

<script>
    import NavigationLinks from './navigation-links'
    import api_fetch from "../api_fetch";

    export default {
        components: {
            NavigationLinks,
        },
        data() {
            return {
                logo: null,
                title: null,
            }
        },
        created() {
            api_fetch('api/App').then((data) => {
                this.logo = data.attributes.Logo;
                this.title = data.attributes.Title;
            });
        }
    }
</script>

<style scoped>
    .navigation-header {
        top: 0;
        width: 100%;
        display: flex;
        z-index: 100;
        position: absolute;
        align-items: center;
        justify-content: center;
    }

    .navigation-max-width {
        width: 100%;
        display: flex;
        z-index: 100;
        position: revert;
        max-width: var(--dl-size-size-maxwidth);
        align-items: center;
        padding-top: var(--dl-space-space-twounits);
        padding-left: var(--dl-space-space-oneandhalfunits);
        padding-right: var(--dl-space-space-oneandhalfunits);
        padding-bottom: var(--dl-space-space-twounits);
        justify-content: space-between;
    }

    .navigation-image {
        width: 91px;
        height: 98px;
    }

    .navigation-nav {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        flex-direction: row;
    }

    .navigation-image1 {
        top: 0;
        left: 0;
        width: 100vw;
        position: absolute;
        max-width: 700px;
        object-fit: cover;
    }

    @media (max-width: 767px) {
        .navigation-max-width {
            padding: var(--dl-space-space-unit);
        }
    }

    @media (max-width: 479px) {
        .navigation-image1 {
            margin-bottom: var(--dl-space-space-unit);
        }
    }
</style>
